import React, { useMemo } from 'react';

export type ResponseSwitch = {
  value: boolean,
  option?: string,
}
type Options = {
  left: string;
  right: string;
}
type SwitcherProps = {
  options?: Options | null;
  isEnable: boolean;
  onChange: (data: ResponseSwitch) => void
  switcherId?: string;
  disabled?: boolean;
}

const Switcher: React.FC<SwitcherProps> = ({ options = null, isEnable, onChange, switcherId, disabled = false }) => {
  const switcherOptions = options ? new Map([[true, options.left], [false, options.right]]) : null;

  const handleChange = () => {
    const response: ResponseSwitch = {
      value: !isEnable,
    };

    if (options) {
      response.option = switcherOptions.get(response.value)
    };

    onChange(response)
  }

  const inputId = useMemo(() => {
    if (!switcherId) {
      return 'switcher'
    }

    return switcherId
  }, [switcherId]);

  return (
    <label
      htmlFor={inputId}
      className={`flex select-none items-center max-w-fit ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
    >
      <div className="relative">
        <input
          type="checkbox"
          id={inputId}
          className="sr-only"
          onChange={handleChange}
          disabled={disabled}
        />
        <div className="flex justify-between items-center h-8 w-16 px-2 rounded-full bg-stroke">
          {options && (
            <>
              <span className='text-sm'>{options.left}</span>
              <span className='text-sm'>{options.right}</span>
            </>
          )}
        </div>
        <div
          className={`absolute top-1 flex h-6 w-6 items-center justify-center rounded-full bg-primary ${isEnable ? 'right-1' : 'left-1'
          }`}
          style={{
            transition: 'all 0.3s ease-in-out',
          }}
        ></div>
      </div>
    </label>
  );
};

export default Switcher;
